import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import Select from '@/components/Select';

import useFilterProps from '@/hooks/useFilterProps';
import { SelectValue } from '@/hooks/useControlSelectValue';
import useCommandMasters from '@/hooks/useCommandMasters';

import { FilterSelectProps } from '@/types/filters';
import useMasterFilter from '@/filters/useMasterFilter';

const FilterMaster = <Multiple extends boolean = false>(
  props: FilterSelectProps<Multiple> & { queryKey?: string; commandId?: string },
) => {
  const { t } = useTranslation();

  const filterProps = useFilterProps(props);

  const { masters } = useCommandMasters({ commandId: props.commandId });

  const { masterId, setMasterId } = useMasterFilter(props.queryKey, props.isMultiple);

  const handleValueSelect = useCallback(
    <Multiple extends boolean>(value: SelectValue<Multiple>) =>
      setMasterId(value as SelectValue<false>, 'replaceIn', true),
    [setMasterId],
  );

  return (
    <Select
      {...filterProps}
      isClearable
      isControlFromProp
      label={t('roles.user')}
      options={masters}
      onSelect={handleValueSelect}
      value={masterId as unknown as SelectValue<Multiple>}
    />
  );
};

export default FilterMaster;
